export const textAlignClassName = (alignment) => alignment ? `has-text-${alignment}` : undefined;
export const textColorClassName = (color) => color ? `has-text-${color}` : undefined;
